<template>
  <MainMenuViewDesktop v-if="isDesktop">
    <slot />
  </MainMenuViewDesktop>
  <MainMenuViewMobile v-else>
    <slot />
  </MainMenuViewMobile>
</template>

<script>
import { mapGetters } from 'vuex';
import MainMenuViewDesktop from './main-menu-view-desktop';
import MainMenuViewMobile from './main-menu-view-mobile';

export default {
  components: { MainMenuViewDesktop, MainMenuViewMobile },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
